import { db, functions } from 'config/firebase';
import { ChartsByLabel, PerformanceTest } from 'interfaces/performanceTest';
import { fireConverter } from './helpers';

import { createClient } from '@supabase/supabase-js';
const supabase = createClient(
  process.env.NEXT_PUBLIC_SUPABASE_API_URL,
  process.env.NEXT_PUBLIC_SUPABASE_ANON_TOKEN
);

export const getReport = async (
  reportUuid: string
): Promise<PerformanceTest> => {
  const reportDocRef = await db
    .collection('reports')
    .withConverter(fireConverter<PerformanceTest>())
    .doc(reportUuid)
    .get();

  if (reportDocRef.exists) {
    return reportDocRef.data();
  } else {
    throw 'Report not found';
  }
};

export const getRecentReports = async (
  uid: string
): Promise<PerformanceTest[]> => {
  const from = new Date();
  from.setTime(from.getTime() - 24 * 60 * 60 * 1000 * 30);

  // TODO(bobsin): better support pages
  const queryRef = await db
    .collection('reports')
    .withConverter(fireConverter<PerformanceTest>())
    .where('createdAt', '>', Math.floor(from.getTime() / 1000))
    .where('userId', '==', uid)
    .orderBy('createdAt', 'desc')
    .limit(20)
    .get();

  return queryRef.docs.map((doc) => doc.data());
};

export const createReport = async (label: string): Promise<PerformanceTest> => {
  const result = await functions.httpsCallable('createReport')({
    label,
  });

  return result.data.data;
};

export const deleteReport = async (reportUuid: string): Promise<void> => {
  return db
    .collection('reports')
    .withConverter(fireConverter<PerformanceTest>())
    .doc(reportUuid)
    .delete();
};

export const getReportChartDataV1 = async (
  reportId: string
): Promise<ChartsByLabel> => {
  const { data, error } = await supabase.rpc('get_report_chart_data_v1', {
    report_id: reportId,
  });

  if (error) {
    throw error;
  }

  return data.reduce((acc, curr) => {
    acc[curr.label] = curr;
    return acc;
  }, {});
};
